"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

var DateTimePicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DateTimePicker, _Component);

  function DateTimePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DateTimePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DateTimePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onDateChange", function (selectedDate) {
      _this.setState({
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onTimeChange", function (selectedTime) {
      _this.setState({
        selectedTime: selectedTime
      });
    });
    var id = props.id,
        _selectedDate = props.selectedDate,
        _selectedTime = props.selectedTime,
        tooltipType = props.tooltipType,
        tooltipMessage = props.tooltipMessage,
        tooltipPosition = props.tooltipPosition,
        updateTooltipPositionOnMove = props.updateTooltipPositionOnMove,
        onTooltipHidden = props.onTooltipHidden;

    if (!id) {
      throw new Error("The prop 'id' is required to make DateTimePicker accessible for users using assistive technologies such as screen readers. Check the render method of DateTimePicker.");
    }

    if (tooltipType || tooltipMessage || tooltipPosition || updateTooltipPositionOnMove || onTooltipHidden) {
      throw new Error('Tooltip support inside of DateTimePicker was removed in v6.0.0. Use dateNode and timeNode getters in a parent component to add tooltips manually as necessary.');
    }

    _this.state = {
      selectedDate: _selectedDate,
      selectedTime: _selectedTime
    };
    return _this;
  }

  (0, _createClass2.default)(DateTimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onChange = this.props.onChange;
      var _this$state = this.state,
          selectedDate = _this$state.selectedDate,
          selectedTime = _this$state.selectedTime;
      var prevSelectedDate = prevState.selectedDate,
          prevSelectedTime = prevState.selectedTime;

      if ((selectedDate !== prevSelectedDate || selectedTime !== prevSelectedTime) && onChange) {
        onChange({
          selectedDate: selectedDate,
          selectedTime: selectedTime
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          id = _this$props.id,
          useIcons = _this$props.useIcons,
          iconPosition = _this$props.iconPosition,
          dateLabel = _this$props.dateLabel,
          dateDisplayFormat = _this$props.dateDisplayFormat,
          timeDisplayFormat = _this$props.timeDisplayFormat,
          datePlaceholder = _this$props.datePlaceholder,
          timeLabel = _this$props.timeLabel,
          timePlaceholder = _this$props.timePlaceholder,
          dateName = _this$props.dateName,
          timeName = _this$props.timeName,
          timeStep = _this$props.timeStep,
          calendarClassName = _this$props.calendarClassName,
          overrideInitialMonthWithSelected = _this$props.overrideInitialMonthWithSelected,
          disablePast = _this$props.disablePast,
          disableDateBefore = _this$props.disableDateBefore,
          disableDateAfter = _this$props.disableDateAfter,
          disableTimeBefore = _this$props.disableTimeBefore,
          disableTimeAfter = _this$props.disableTimeAfter,
          useTetherShim = _this$props.useTetherShim,
          disabled = _this$props.disabled;
      var _this$state2 = this.state,
          selectedDate = _this$state2.selectedDate,
          selectedTime = _this$state2.selectedTime;
      var classes = (0, _classnames.default)('DateTimePicker', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_DatePicker.default, {
        ref: function ref(node) {
          _this2._datePicker = node;
        },
        id: id,
        name: dateName,
        displayFormat: dateDisplayFormat,
        calendarClassName: calendarClassName,
        useIcon: useIcons,
        iconPosition: iconPosition,
        disabled: disabled,
        label: dateLabel,
        placeholder: datePlaceholder,
        selectedDate: selectedDate,
        overrideInitialMonthWithSelected: overrideInitialMonthWithSelected,
        onChange: this._onDateChange,
        disablePast: disablePast,
        disableBefore: disableDateBefore,
        disableAfter: disableDateAfter,
        useTetherShim: useTetherShim
      }), _react.default.createElement(_TimePicker.default, {
        ref: function ref(node) {
          _this2._timePicker = node;
        },
        name: timeName,
        useIcon: useIcons,
        displayFormat: timeDisplayFormat,
        iconPosition: iconPosition,
        disabled: disabled,
        label: timeLabel,
        placeholder: timePlaceholder,
        selectedTime: selectedTime,
        step: timeStep,
        disableBefore: disableTimeBefore,
        disableAfter: disableTimeAfter,
        onChange: this._onTimeChange
      }));
    }
  }, {
    key: "dateNode",

    /**
     * Getter for the date picker input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */
    get: function get() {
      return this._datePicker.node;
    }
    /**
     * Getter for the time picker select DOM element.
     *
     * @public
     * @returns {Element} - The select element.
     */

  }, {
    key: "timeNode",
    get: function get() {
      return this._timePicker.node;
    }
  }]);
  return DateTimePicker;
}(_react.Component);

exports.default = DateTimePicker;
(0, _defineProperty2.default)(DateTimePicker, "defaultProps", {
  useIcons: true,
  timeStep: 30,
  disablePast: true,
  overrideInitialMonthWithSelected: true,
  iconPosition: 'right'
});